export enum MouseActionType {
  MouseOver = 'MouseOver',
  MouseLeave = 'MouseLeave',
  Edit = 'Edit',
  Blur = 'Blur',
}
